import React from 'react'
import Icons from '../../Constants/Icons'
const UserApplicationRenderItem = ({
  currentUsers,
  setIsVisible,
  onApprove
  , onClickUser
}) => {
  return (
    <div className='register-min'>
      <div
        className='scrollable-container'
        style={{ background: 'transparent' }}
      >
        {currentUsers?.map((currentUsers, index) => (
          <div key={index}>
            <div className='list-user-div-container border-bottom'>
              <div className='grid-cols grid_7'>
                      <div
                  onClick={() => onClickUser(currentUsers)}
                  className="fontSize16WithoutFlex  user_name alignItems pointer w-22"
                >
                  <img
                    src={currentUsers.image ?? Icons.ic_default_user}
                    className="currentUsers-image"
                  />
                  <div
                    className="user_text pointer"
                    onClick={() => onClickUser(currentUsers)}
                  >
                    {currentUsers.name}
                  </div>
                </div>
                <div onClick={() => onClickUser(currentUsers)} className='fontSize16WithoutFlex user_name w-12 pointer'>
                  {currentUsers.userName}
                </div>
                <div onClick={() => onClickUser(currentUsers)} className='user_name w-20 block pointer'>
                  <div className='fontSize16WithoutFlex alignItems '>
                    <img className='sms-res' src={Icons.ic_sms} alt='new' />
                    <div className='user_text'>{currentUsers.userEmail}</div>
                  </div>
                  <div className='fontSize16WithoutFlex flex-container '>
                    <img
                      className='icon_style_list '
                      alt=''
                      src={Icons.ic_call}
                    />
                    <div className='user_text'>{currentUsers.mobile}</div>
                  </div>
                </div>
                <div onClick={() => onClickUser(currentUsers)} className='fontSize16WithoutFlex user_name w-8 pointer'>
                  {currentUsers.birthDate}
                </div>
                <div onClick={() => onClickUser(currentUsers)} className='fontSize16WithoutFlex user_name w-14 pointer'>
                  {currentUsers.currentUserType}
                </div>
                <div onClick={() => onClickUser(currentUsers)} className='fontSize16WithoutFlex user_name w-14 pointer'>
                  {currentUsers.applicationUserType}
                </div>

                <div style={{}} className='w-10'>
                  <div
                    style={{ cursor: 'default' }}
                    className='user_Status pointer'
                  >
                    <div
                      style={{
                        color:
                          !currentUsers.isApprove && !currentUsers.isReject
                            ? ' #ff9933'
                            : currentUsers.isReject
                              ? '#f04438'
                              : '#12b76a'
                      }}
                      className='button'
                    >
                      {!currentUsers.isApprove && !currentUsers.isReject
                        ? 'Pending'
                        : currentUsers.isReject
                          ? 'Reject'
                          : 'Approve'}
                    </div>
                  </div>
                </div>
                <div style={{}} className='w-10'>
                  <div
                    onClick={() => onApprove(currentUsers)}
                    className='user_Status pointer'
                  >
                    <button className='button pointer approve-button'>
                      {'Approve'}
                    </button>
                  </div>
                  <div
                    style={{ marginTop: '5px' }}
                    className='user_Status pointer'
                  >
                    <button
                      className='button pointer reject-button'
                      onClick={() => setIsVisible(currentUsers)}
                    >
                      {'Reject'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UserApplicationRenderItem
